__turbopack_context__.v({
  "triggerButton": "pLIYca_triggerButton",
  "triggerIcon": "pLIYca_triggerIcon",
  "wrapper": "pLIYca_wrapper",
});
